import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { ConfigPage } from '../pages/config/config';
import { PropertiesPage } from '../pages/properties/properties';
import { AuthService } from '../services/auth.service';
import { UserStore } from '../stores/user.store';
import { ConfigStore } from '../stores/config.store';

@Component({
    templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  
  rootPage: any = HomePage;

  pages: Array<{icon: string, title: string, component: any, params: any}>;

  constructor(
        public platform: Platform,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        private auth: AuthService,
        private userStore: UserStore,
        private config: ConfigStore) {

    // ToDo: riscrivere l'inizializzazione della pagina in maniera pi� ordinata

    if (!auth.isLoggedIn()) {
        this.rootPage = LoginPage
    }
    else if (this.config.data.lastVersionInfo != this.config.currentVersion) {
        this.rootPage = HomePage;
    }
    else {
        
        switch (config.data.defaultCategory) {
            case 'R': this.rootPage = PropertiesPage; break;

            //  ToDo: completare

            default:
                throw new Error('Categoria non valida!');
        }
    }

    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
        { icon: 'information-circle', title: 'Informazioni', component: HomePage, params: {disabled: false} },      
        { icon: 'home', title: 'Residenziali', component: PropertiesPage, params: { title: 'Residenziali', category: 'R', disabled: false } },
        { icon: '', title: 'Commerciali', component: PropertiesPage, params: { disabled: true } },
        { icon: '', title: 'Industriali', component: PropertiesPage, params: { disabled: true } },
        { icon: '', title: 'Terreni', component: PropertiesPage, params: { disabled: true } },
        { icon: '', title: 'Richieste', component: HomePage, params: { disabled: true } }
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario

      if (page)
      {
          if (HomePage == page.component)
              this.nav.push(HomePage);
          else
              this.nav.setRoot(page.component, page.params);
      } else
        this.nav.push(ConfigPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts